import { render, staticRenderFns } from "./RecipientAttachments.vue?vue&type=template&id=09c6019a&"
import script from "./RecipientAttachments.vue?vue&type=script&lang=js&"
export * from "./RecipientAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports